const blog = {
  hero: {
    eyebrow: "Insights & Analysis",
    title0:  "Dubai Real Estate",
    title1:  "Expert Blog",
    sub:     "Market intelligence, investment strategies, and legal guides written by ProNet's senior consultants — to help you buy, invest, and grow in Dubai.",
  },
  search: {
    placeholder: "Search articles…",
    label:       "Search articles",
    noResults:   "No articles found",
    noResultsSub:"Try a different search term or browse all categories.",
    clearFilters:"Clear filters",
  },
  filter: {
    all:   "All",
    label: "Filter by category",
  },
  card: {
    read: "Read article",
  },
  loading: "Loading articles…",
  featured: "Featured article",
  toc:      "Contents",
  share:    "Share",
  tags:     "Article tags",
  faq: {
    eyebrow: "FAQ",
    title0:  "Frequently Asked",
    title1:  "Questions",
  },
  related: {
    eyebrow: "Continue Reading",
    title0:  "Related",
    title1:  "Articles",
  },
  cta: {
    eyebrow:  "Free Consultation",
    title0:   "Ready to invest in",
    title1:   "Dubai real estate?",
    sub:      "Speak with one of our senior consultants. We will analyse your goals, budget, and timeline — and find the right property for you.",
    whatsapp: "WhatsApp Us →",
    message:  "Send a Message",
  },
  sidebar: {
    ctaLabel:   "Free Consultation",
    ctaText:    "Talk to a Dubai property specialist. We'll find the right investment for your goals.",
    whatsapp:   "WhatsApp Us →",
    message:    "Or send a message",
  },
  postCta: {
    eyebrow:  "Ready to invest?",
    title0:   "Book a free property",
    title1:   "consultation",
    sub:      "Our senior consultants have helped hundreds of international investors buy, rent, and grow their portfolio in Dubai. Let us do the same for you.",
    whatsapp: "WhatsApp Us →",
    browse:   "Browse Properties",
  },
  sticky: "Get Consultation",
  minRead: "min read",
  updated: "Updated",
};

export default blog;
